<!--
&& !nvdbNavigationService.isMobileDevice
-->
@if (initialized) {
    <div class='map-main__buttons__btnlist'>
        <app-map-button
            [svgIcon]='handIcon'
            [active]='trvMapService.trvMap!.activeMapTool!.value == MapTools.Pointer'
            (click)='setMapTool(MapTools.Pointer)'
            [toolTip]="lang.GetValue('ToolsMenu.Pan')"
            [toolTipPosition]="toolTipPositions"
        ></app-map-button>
        <app-map-button
            [svgIcon]='zoomIconPlus'
            [active]='trvMapService.trvMap?.activeMapTool?.value == MapTools.Zoom'
            (click)='setMapTool(MapTools.Zoom)'
            [toolTip]="lang.GetValue('ToolsMenu.ZoomRec')" 
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
        <app-map-button
            [svgIcon]='swedenIcon'
            [specialSvg]='true'
            (click)='gotoSweden()'
            [toolTip]="lang.GetValue('ToolsMenu.ViewSwe')"
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
        <app-map-button
            [svgIcon]='rulerIcon'
            [active]='trvMapService.trvMap?.activeMapTool?.value == MapTools.Ruler'
            (click)='setMapTool(MapTools.Ruler)'
            [toolTip]="lang.GetValue('ToolsMenu.Measure')"
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
        <app-map-button
            [svgIcon]='pinIcon'
            [active]='trvMapService.trvMap?.activeMapTool?.value == MapTools.PinPosition'
            (click)='setMapTool(MapTools.PinPosition)'
            [toolTip]="lang.GetValue('ToolsMenu.ShowCoor')"
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
        <app-map-button [svgIcon]='eraserIcon' (click)='eraser()' [toolTip]="lang.GetValue('ToolsMenu.ClearMap')"
                        [toolTipPosition]='toolTipPositions'></app-map-button>
        <app-map-button
            [svgIcon]='printerIcon'
            [active]='trvMapService.trvMap?.activeMapTool?.value == MapTools.ExportRectangle'
            (click)='changeNavigationState(NavigationState.PrintMap);'
            [toolTip]="lang.GetValue('ToolsMenu.PrintForm')"
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
        
        @if (environment.application == "NjdbPåWebb") {
            <app-map-button
            #bandelPopoverRef='trvPopover'
            [manualToggle]='true'
            (click)='showBandelPopover($event)'
            [trvPopover]='bandelSearchComponent'
            (afterCloseWithType)='onAfterCloseBandel($event)'
            (shown)='onShowBandel($event)' 
            [svgIcon]='svgMapLocation'
            toolTip='Zooma till koordinat eller kilometertal'
            [toolTipPosition]='toolTipPositions'
            ></app-map-button>
        }

        <app-map-button
            [svgIcon]='infoIcon'
            [active]='trvMapService.trvMap?.activeMapTool?.value == MapTools.InfoClick'
            (click)='changeNavigationState(NavigationState.InfoClick)'
            [toolTip]="lang.GetValue('ToolsMenu.InfoClick')"
            [toolTipPosition]='toolTipPositions'
        ></app-map-button>
    </div>
}
